<template>
    <div data-testid="platform-stats">
        <CountUpItem
            :end="userStats.number"
            :should-start="startCount"
            :options="{
                separator: counterSeparator,
                decimalPlaces: 2,
                suffix: ' ' + userStats.format,
            }"
            :size="size"
            data-testid="user-count"
            icon="course"
        >
            <template #label>
                <span :class="{ 'text-xs': size === 'sm' }">
                    {{ t('university_search.counters.course') }}
                </span>
            </template>
        </CountUpItem>
        <CountUpItem
            :end="docStats.number"
            :should-start="startCount"
            :options="{
                separator: counterSeparator,
                decimalPlaces: 2,
                suffix: ' ' + docStats.format,
            }"
            :size="size"
            icon="document"
        >
            <template #label>
                <span :class="{ 'text-xs': size === 'sm' }">
                    {{ t('university_search.counters.document') }}
                </span>
            </template>
        </CountUpItem>
        <CountUpItem
            :end="postStats.number"
            :should-start="startCount"
            :options="{
                separator: counterSeparator,
                decimalPlaces: 2,
                suffix: ' ' + postStats.format,
            }"
            :size="size"
            icon="chat"
        >
            <template #label>
                <span :class="{ 'text-xs': size === 'sm' }">
                    {{ t('university_search.counters.chat') }}
                </span>
            </template>
        </CountUpItem>
    </div>
</template>

<script>
import CountUpItem from '@components/CountUpItem';
import { mapGetters } from 'vuex';
import { formatLongNumbers } from '@helpers/formatLongNumbers';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'Platformstats',
    components: {
        CountUpItem,
    },
    props: {
        size: {
            type: String,
            default: 'md',
            validator(value) {
                // The value must match one of these strings
                return ['sm', 'md'].indexOf(value) !== -1;
            },
        },
    },
    setup() {
        const { t } = useTranslation('homepage');
        return { t };
    },
    data() {
        return {
            startCount: false,
            counterSeparator: ',',
        };
    },
    computed: {
        ...mapGetters('platform', ['statsPlatform']),
        userStats() {
            return formatLongNumbers(this.statsPlatform.users);
        },
        docStats() {
            return formatLongNumbers(this.statsPlatform.documents);
        },
        postStats() {
            return formatLongNumbers(this.statsPlatform.posts);
        },
    },
    watch: {
        statsPlatform(newValue) {
            if (newValue) {
                this.startCount = true;
                this.counterSeparator = this.t('university_search.counters.separator');
            }
        },
    },
    created() {
        this.retrievePlatformStats();
    },
    mounted() {
        if (this.statsPlatform.users > 0 && !this.startCount) {
            this.startCount = true;
        }
    },
    methods: {
        retrievePlatformStats() {
            if (this.statsPlatform.users === 0) {
                this.$store.dispatch('platform/retrievePlatformStats');
            }
        },
    },
};
</script>
